import React from 'react';

interface CTASectionProps {
  title: string;
  description: string;
  buttonText: string;
  buttonLink: string;
  buttonIcon?: string;
}

const CTASection: React.FC<CTASectionProps> = ({
  title,
  description,
  buttonText,
  buttonLink,
  buttonIcon
}) => {
  return (
    <section className="cta-section" style={{padding: '80px 0', background: 'linear-gradient(135deg, #FF6B35 0%, #F7931E 100%)'}}>
      <div className="container">
        <div className="row">
          <div className="col-lg-8 mx-auto text-center">
            <h2 className="cta-section__title text-white mb-4" style={{fontSize: '2.5rem', fontWeight: 700}}>{title}</h2>
            <p className="cta-section__description text-white mb-5" style={{fontSize: '1.2rem', opacity: 0.9}}>{description}</p>
            <a href={buttonLink} className="btn-main" style={{background: 'white !important', color: '#FF6B35 !important', padding: '18px 40px', fontSize: '1.1rem'}}>
              {buttonText}
              {buttonIcon && <><i className={`${buttonIcon} ms-2`} aria-hidden /></>}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;

